export const AI_PROVIDERS = [
  {
    id: 'google',
    label: 'Google Gemini',
    recipient: 'Google LLC (Gemini)',
  },
  {
    id: 'groq',
    label: 'Groq',
    recipient: 'Groq, Inc.',
  },
  {
    id: 'anthropic',
    label: 'Claude',
    recipient: 'Anthropic, PBC (Claude)',
  },
] as const;

export type AiProviderId = (typeof AI_PROVIDERS)[number]['id'];

export function getAiProviderLabel(provider: string | null | undefined): string {
  return AI_PROVIDERS.find((entry) => entry.id === provider)?.label ?? 'Selected provider';
}

export function getAiProviderRecipient(provider: string | null | undefined): string {
  return AI_PROVIDERS.find((entry) => entry.id === provider)?.recipient ?? 'Selected AI provider';
}
